import React, { FC } from 'react';
import { HStack, Text, VStack } from '@chakra-ui/react';
import { toOptionalFixed } from '@app/helpers/format';
import { TokenIcon } from '@app/components/TokenIcon';
import { getCurrencySymbol } from '@app/helpers/currency';
import { Token } from '@app/types/token';
import { Address } from '@thirdweb-dev/sdk';

interface Props {
  token0Address: Address;
  token1Address: Address;
  token0Symbol: string;
  token1Symbol: string;
  amount0: string | number;
  amount1: string | number;
}

export const CompositionSection: FC<Props> = ({
  token0Address,
  token1Address,
  token0Symbol,
  token1Symbol,
  amount1,
  amount0
}) => {
  return (
    <VStack alignItems="flex-start" gap={1}>
      <HStack>
        <TokenIcon
          symbol={
            getCurrencySymbol({
              contractAddress: token0Address,
              symbol: token0Symbol
            } as Token) as string
          }
        />
        <Text fontSize="16px" lineHeight="26px" color="white">
          {amount0 ? toOptionalFixed(+amount0, 5) : ''}
        </Text>
      </HStack>
      <HStack>
        <TokenIcon
          symbol={
            getCurrencySymbol({
              contractAddress: token1Address,
              symbol: token1Symbol
            } as Token) as string
          }
        />
        <Text fontSize="16px" lineHeight="26px" color="white">
          {amount1 ? toOptionalFixed(+amount1, 5) : ''}
        </Text>
      </HStack>
    </VStack>
  );
};
